export default class Navigator {
	constructor() {
		this.browser = null;

		this.init();
	}

	init() {
		this.detectBrowser();
		this.setBodyClass();
	}

	detectBrowser() {
		const ua = navigator.userAgent;

		if (ua.search(/Safari/) > 0) this.browser = "safari";
		if (ua.search(/Chrome/) > 0) this.browser = "chrome";
		if (ua.search(/MSIE/) > 0) this.browser = "ie";
		if (ua.search(/Firefox/) > 0) this.browser = "firefox";
		if (ua.search(/Opera/) > 0) this.browser = "opera";
	}

	setBodyClass() {
		if (this.browser) {
			document.body.classList.add(`-${this.browser}`);
		}
	}
}